<template>

<svg :id="'connection'+connection.id"  class="calculation_connection" :class="drawclass">
  <!--<line :x1="connection.x1" :y1="connection.y1" :x2="connection.x2" :y2="connection.y2"  />-->
  <path   :d="path_coordinates" fill="none" />
</svg>

</template>

<script>
export default {

  name: 'CalculationConnection',
  props:["connection"],
  computed:{
  	drawclass()
  	{
  		if(this.connection.drawing)
  		{
  			return "drawing"
  		}
  		else
  		{
  			return "drawn"
  		}
  	},
    path_coordinates()
    {
      let connection = this.connection
      let start_coordinate
      let end_coordinate
      let curve_coordinate
      if(connection.x1 && connection.y1)
      {
        start_coordinate = "M"+connection.x1+" "+connection.y1+", "
      }
      if(connection.x2 && connection.y2)
      {
        end_coordinate = ", "+connection.x2+" "+connection.y2
      }
      let vertical_factor = 1
      if(connection.y1>connection.y2 || connection.y2>connection.y1)
      {
        vertical_factor = (connection.y1-connection.y2)*0.5
      }



      let curve_x = ((connection.x2-connection.x1)/2)+connection.x1
      let curve_y = ((connection.y2-connection.y1)/2)+connection.y1 + vertical_factor
      curve_coordinate = "C"+curve_x+" "+curve_y+" "+curve_x+" "+curve_y

      return start_coordinate+curve_coordinate+end_coordinate

    }
  },
  data () {
    return {

    }
  }
}
</script>

<style lang="css" scoped>
</style>